<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="overlay" v-if="loadingStatsSecretariat">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Statistiques générales pour le secrétariat</h3>
          <!--<button class="btn btn-default btn-xs pull-right"-->
          <!--@click.prevent="getStatsComites(true)">-->
          <!--<i class="fa fa-refresh "></i>-->
          <!--</button>-->
        </div>
        <div class="box-body">
          <div class="col-md-4">
            <h4>Fichiers particuliers pour le secrétariat</h4>
            <ul>
              <li><a href="#" @click.prevent="StatsGeneralesForProvincesADEPSExcelFormat2022(moment().year())">Export
                excel des statistiques membres ADEPS par âge en {{ moment().year() }} (pour subvention ADEPS) </a></li>
              <li><a href="#" @click.prevent="StatsGeneralesForProvincesADEPSExcelFormat2022(moment().year()-1)">Export
                excel des statistiques membres ADEPS par âge en {{ moment().year() -1}} (pour subvention ADEPS) </a></li>
            </ul>
            <ul>
              <li><a href="#" @click.prevent="generateExcelAideSubventionADEPS(moment().year(),moment().year())">Export
                excel des clubs affiliés en {{ moment().year() }} avec le nombre de membres en {{ moment().year()}}
                (pour subvention ADEPS) </a></li>
              <li><a href="#" @click.prevent="generateExcelAideSubventionADEPS(moment().year()-1,moment().year()-1)">Export
                excel des clubs affiliés en {{ moment().year()-1 }} avec le nombre de membres en {{ moment().year()-1}}
                (pour subvention ADEPS) </a></li>
            </ul>
            <ul>
              <li><a href="#" @click.prevent="exportListeCotisation(moment().year())">Export excel de la liste des
                cotisations clubs en {{ moment().year() }}</a></li>
              <li><a href="#" @click.prevent="exportListeCotisation(moment().year()-1)">Export excel de la liste des
                cotisations clubs en {{ moment().year() - 1 }}</a></li>
            </ul>
            <ul>
              <li><a href="#" @click.prevent="etiquetteIndividuelleClubForFlyer(moment().year())">Export étiquettes
                flyers des clubs en {{ moment().year() }}</a></li>
              <li><a href="#" @click.prevent="etiquetteIndividuelleClubForFlyer(moment().year()-1)">Export étiquettes
                flyers des clubs en {{ moment().year() - 1 }}</a></li>
            </ul>

            <ul>
              <li><a href="#" @click.prevent="exportMailsFromClub([moment().year()])">Export e-mails des clubs licenciés
                en {{ moment().year() }}</a></li>
              <li><a href="#" @click.prevent="exportMailsFromClub([moment().year(),moment().year()-1])">Export e-mails
                des clubs licenciés en {{ moment().year() }} et {{ moment().year() - 1 }}</a></li>
            </ul>
          </div>
          <div class="col-md-4">
            <h4>Statistiques particulières pour le secrétariat</h4>
            <ul>
              <li v-for="annee in getAnnees().reverse()">
                <a href="#" @click.prevent="getListingClubExcel(annee)">Listing clubs en excel pour {{ annee }}</a>
              </li>
            </ul>
          </div>
          <div class="col-md-4">
            <h4>Statistiques pour l'ADEPS pour le secrétariat</h4>
            <ul>
              <li v-for="annee in getAnnees().reverse()">
                <a href="#" @click.prevent="getStatsExcel(annee)">Listing clubs en excel pour {{ annee }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">Filtre et recherche (tout encodage de membre confondu)</h3>
          <button type="button"
                  class="btn btn-xs btn-default btn-flat margin pull-right"
                  style="margin-top: 0;margin-bottom: 0;"
                  @click="resetFilter()"
          >
            Réinitialiser les filtres
          </button>
        </div>
        <div class="box-body">
          <div class="col-md-3">
            <list-select-club
              :clubsLicenciesUniquement="false"
              title="Filtrer par club"
              :showOptionTousLesClubs="true"
              :clubPreSelected="clubSelectedForFilter"
              :reset="reset"
              @clubSelected="updateClubSelected"
            ></list-select-club>
          </div>
          <div class="col-md-2 input-daterange" id="dataRange">
            <div class="form-group">
              <label>Du:</label>
              <div class="input-group date ">
                <div class="input-group-addon">
                  <i class="fa fa-calendar"></i>
                </div>
                <input type="text" name="periodeDu" v-model="periodeDu"
                       class="form-control pull-right datepicker" id="datepicker1">
              </div>
              <!-- /.input group -->
            </div>
            <div class="form-group ">
              <label>Au:</label>
              <div class="input-group date ">
                <div class="input-group-addon">
                  <i class="fa fa-calendar"></i>
                </div>
                <input type="text" name="periodeAu" v-model="periodeAu"
                       class="form-control pull-right datepicker" id="datepicker2">
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <input type="submit" @click.prevent="searchLicences()" value="Rechercher" class="btn btn-primary pull-right"/>
        </div>
        <hr>
        <div class="box-header with-border">
          <b-col md="9" class="my-1">
            <h3 class="box-title">Listing des licences: {{ pagination_meta.total }}
              résultat{{ pagination_meta.total > 1 ? 's' : '' }}</h3>
          </b-col>
          <b-col md="3" class="my-1">
            <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
          </b-col>
        </div>
        <div class="box-body ">
          <b-table
            id="tableListingAllRecaps"
            v-if="!loadingListingLicences && listingLicences.length>0"
            responsive bordered striped hover
            :items="listingLicences"
            :filter="filter"
            :fields="columnsListingLicences"
            :per-page="pagination_meta.per_page"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :empty-text="'Aucun résultat'"
            :empty-filtered-text="'Aucun résultat'"
            foot-clone
            show-empty
          >
            <template slot="actions" slot-scope="row">
              <router-link
                class="btn btn-default padding2"
                :to="{ name: 'Recap', params: { recap_id: row.item.id }}">
                <i class="glyphicon glyphicon-pencil"></i>
              </router-link>
            </template>
            <template slot="date" slot-scope="row">
              {{ formatDate(row.item.date.date) }}
            </template>
            <template slot="id" slot-scope="row">
              {{ row.item.id | idFormat }}
            </template>
            <template slot="recap" slot-scope="row">
              <router-link
                v-if="row.item.recap.id"
                :to="{ name: 'Recap', params: { recap_id: row.item.recap.id}}">
                Récapitulatif {{ row.item.recap.id | idFormat }}
              </router-link>
            </template>
            <template slot="nom" slot-scope="row">
              <router-link
                :to="{ name: 'Member', params: { member_id: row.item.membre.id }}">
                {{ row.item.membre.nom }}
              </router-link>
            </template>

            <template slot="prenom" slot-scope="row">
              <router-link
                :to="{ name: 'Member', params: { member_id: row.item.membre.id }}">
                {{ row.item.membre.prenom }}
              </router-link>
            </template>

            <template slot="club" slot-scope="row">
              <router-link :to="{ name: 'Club', params: { club_id: row.item.club.id }}">
                {{ row.item.club.club }}
              </router-link>
            </template>
          </b-table>
          <b-pagination size="md"
                        @change="changePage"
                        :total-rows="pagination_meta.total"
                        v-model="pagination_meta.current_page"
                        :per-page="pagination_meta.per_page">
          </b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

require('../../../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker')
require('../../../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr')


var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');
import vSelect from '../../../Communs/vSelect/index'
import ListSelectClub from '../../../Communs/listeSelectClub'

export default {
  data() {
    return {
      loadingStatsSecretariat: false,

      clubSelectedForFilter: -1,
      sortBy: null,
      sortDesc: null,
      filter: null,
      listingLicences: [],
      loadingListingLicences: true,
      isBusy: false,
      current_page: 1,
      periodeDu: null,
      periodeAu: null,
      statutRecherche: 0,
      reset: false,
      pagination_meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 20,
        to: 1,
        total: 1
      },
      columnsListingLicences: [
        {
          label: 'Date',
          key: 'date',
          sortable: true,
        },
        {
          label: 'Numéro',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Recapitulatif',
          key: 'recap',
          sortable: true,
        },
        {
          label: 'Nom',
          key: 'nom',
          sortable: false,
        },
        {
          label: 'Prénom',
          key: 'prenom',
          sortable: false,
        },
        {
          label: 'Club',
          key: 'club',
          sortable: true,
        },
      ]
    }

  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getProvinces: 'getProvinces',
      getStatusRecap: 'getStatusRecap',
    }),

  },
  mounted: function () {
    var these = this
    if (this.clubPreSelected > 0)
      this.clubSelectedForFilter = this.clubPreSelected
    this.periodeDu = "01/01/" + moment().format("YYYY")
    this.periodeAu = moment().format("DD/MM/YYYY")
    this.getTableListingLicences();
    these.periodeDu = '01/01/' + moment().format('Y')
    these.periodeAu = moment().format('D/M/Y')
    this.$nextTick(function () {
      $('.input-daterange').datepicker({
        autoclose: true,
        language: 'fr',
      }).on("changeDate", function (e) {
        these.periodeDu = $('#datepicker1').val()
        these.periodeAu = $('#datepicker2').val()
      });
    })
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
      setProvinces: 'setProvinces',
    }),
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    searchLicences: function () {
      this.sortDesc = null;
      this.sortBy = null;
      this.getTableListingLicences();
    },
    getStatsExcel: function (annee) {
      if (!annee)
        return;
      let self = this;
      this.loadingStatsSecretariat = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesForProvincesADEPSExcel'),
        JSON.stringify({
          annee: annee
        }),
        // {responseType: 'blob'}
      ).then((response) => {
        // this.loadingListingLicences = false
        // var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        // FileSaver.saveAs(blob, "ListingExcelAdeps_" + annee + ".xls");
        // return response.blob();
      }, (response) => {
        // self.$noty.error("Erreur dans la génération du fichier XLS")
        // this.loadingListingLicences = false
      });

      setTimeout(() => {
        self.$noty.success("Le fichier demandé vous sera envoyé par mail dés qu'il sera généré.")
        this.loadingStatsSecretariat = false
      }, 2000)
    },

    generateExcelAideSubventionADEPS: function (anneeCotisation, anneeCompteMembre) {
      if (!anneeCotisation || !anneeCompteMembre)
        return;
      let self = this;
      this.loadingStatsSecretariat = true
      this.$http.post
      (
        self.getRoute('Statistiques.generateExcelAideSubventionADEPS'),
        JSON.stringify({
          anneeCotisation: anneeCotisation,
          anneeCompteMembre: anneeCompteMembre,
        }), {responseType: 'blob'},
      ).then((response) => {
        this.loadingStatsSecretariat = false
        var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
        FileSaver.saveAs(blob, "AideSubventionExcel.xls");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier ")
        this.loadingStatsSportif = false
      });

    },
    StatsGeneralesForProvincesADEPSExcelFormat2022: function (annee) {
      if (!annee)
        return;
      let self = this;
      this.loadingStatsSecretariat = true
      this.$http.post
      (
        self.getRoute('Statistiques.StatsGeneralesForProvincesADEPSExcelFormat2022'),
        JSON.stringify({
          date: annee,
        }),
      ).then((response) => {
        // var blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
        // FileSaver.saveAs(blob, "TableauMembreParAgePourSubventionExcel_"+annee+".xls");
        // return response.blob();
      }, (response) => {
        // self.$noty.error("Erreur dans la génération du fichier ")
        // this.loadingStatsSecretariat = false
      });

      setTimeout(() => {
        self.$noty.success("Le fichier demandé vous sera envoyé par mail dés qu'il sera généré.")
        this.loadingStatsSecretariat = false
      },2000)
    },
    changePage: function (e) {
      this.pagination_meta.current_page = e
      this.getTableListingLicences();
    },
    updateClubSelected: function (value) {
      this.clubSelectedForFilter = value.id;
    },
    currentYear: function () {
      return moment().year();
    },
    isTableListingLicencesLoading: function (force = false) {
      if (force)
        return true
      return this.loadingListingLicences;
    },
    getTableListingLicences: function () {
      this.loadingListingLicences = true;
      this.isBusy = true
      let self = this
      // debugger;
      this.$http.post(self.getRoute('Secretariat.Licences.getAll'), this.constructSearchRequest())
        .then((response) => {
          self.listingLicences = response.body.data
          self.pagination_meta = response.body.meta
          self.loadingListingLicences = false;
          self.$root.$emit('bv::refresh::table', 'tableListingAllLicences');
        }, (response) => {
          self.listingLicences = []
          self.$root.$emit('bv::refresh::table', 'tableListingAllLicences');
        });
    },
    resetFilter: function () {
      this.clubSelectedForFilter = null;
      this.periodeDu = null;
      this.periodeAu = null;
      this.montant = null;
      this.reset = !this.reset;
    },
    getAnnees: function () {
      let retour = [];
      for (let i = 2007; i <= moment().year(); i++) {
        retour.push(i)
      }
      return retour;
    },
    moment: function () {
      return moment()
    },
    exportListeCotisation: function (date) {
      if (!date)
        return;
      let self = this;
      this.loadingStatsSecretariat = true
      this.$http.post
      (
        self.getRoute('Secretariat.exportFactureCotisations'),
        JSON.stringify({
          date: date + "-12-31",
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsSecretariat = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "ListingCotisations_" + date + ".xls");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier XLS")
        this.loadingStatsSecretariat = false
      });
    },
    etiquetteIndividuelleClubForFlyer: function (date) {
      if (!date)
        return;
      let self = this;
      this.loadingStatsSecretariat = true
      this.$http.post
      (
        self.getRoute('Secretariat.etiquetteIndividuelleClubForFlyer'),
        JSON.stringify({
          year: date,
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsSecretariat = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "Etiquettes_" + date + ".pdf");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier ")
        this.loadingStatsSecretariat = false
      });
    },
    exportMailsFromClub: function (date) {
      if (!date)
        return;
      let self = this;
      this.loadingStatsSecretariat = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportMailsFromClub'),
        JSON.stringify({
          years: date,
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsSecretariat = false
        return this.copyToClipboard(response.body)
      }, (response) => {
        self.$noty.error("Erreur dans la génération de la réponse")
        this.loadingStatsSecretariat = false
      });
    },
    copyToClipboard: function (message) {
      let self = this;
      this.$copyText(message).then(function (e) {
        self.$noty.success("E-mails copiés dans le presse-papier")

      }, function (e) {
        self.$noty.error("Erreur dans l'accès au presse-papier")
      })
    },
    getListingClubExcel: function (annee) {
      if (!annee)
        return;
      let self = this;
      this.loadingStatsSecretariat = true
      this.$http.post
      (
        self.getRoute('Statistiques.exportListingClubExcel'),
        JSON.stringify({
          annee: annee,
        }),
        {responseType: 'blob'}
      ).then((response) => {
        this.loadingStatsSecretariat = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "ListingClub_" + annee + ".xlsx");
        return response.blob();
      }, (response) => {
        self.$noty.error("Erreur dans la génération du fichier Excel")
        this.loadingStatsSecretariat = false
      });
    },

    loadProvinces: function () {
      this.$http.get(this.getRoute('getAllProvinces')).then((response) => {
        this.setProvinces(response.body)
      }, (response) => {
      });
    },
    constructSearchRequest: function () {
      var objectTemp = {}
      if (this.montant != '' && this.montant != null)
        objectTemp.montant = this.montant
      if (this.montantOptions != '' && this.montantOptions != null)
        objectTemp.montantOptions = this.montantOptions
      if (this.montantLimite != '' && this.montantLimite != null)
        objectTemp.montant_limite = this.montantLimite
      if (this.periodeDu != '' && this.periodeDu != null)
        objectTemp.periodeDu = this.periodeDu
      if (this.periodeAu != '' && this.periodeAu != null)
        objectTemp.periodeAu = this.periodeAu
      if (this.clubSelectedForFilter != '' && this.clubSelectedForFilter > 0 && this.clubSelectedForFilter != null)
        objectTemp.clubSelectedForFilter = this.clubSelectedForFilter

      if (this.statutRecherche != 0 && this.statutRecherche != null)
        objectTemp.statut = this.statutRecherche

      if (this.pagination_meta.per_page != 0 && this.pagination_meta.per_page != null)
        objectTemp.perPage = this.pagination_meta.per_page
      if (this.sortBy != null) {
        let sortDesc = this.sortDesc != null ? this.sortDesc == true ? "asc" : "desc" : "desc"
        objectTemp.sort = this.sortBy + "|" + sortDesc
      }
      if (this.pagination_meta.current_page != 0 && this.pagination_meta.current_page != null)
        objectTemp.currentPage = this.pagination_meta.current_page

      return (objectTemp);
    },

  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
  watch: {
    'sortBy': function (val) {
      this.getTableListingRecap()
    },
    'sortDesc': function (val) {
      this.getTableListingRecap()
    },
    'periodeDu': function (val) {
      this.constructSearchRequest()
    },
    'periodeAu': function (val) {
      this.constructSearchRequest()
    },
    'clubSelectedForFilter': function (val) {
      this.constructSearchRequest()
    },
    'clubPreSelected': function (val) {
      this.clubSelectedForFilter = val
    },

  },
  components: {
    vSelect,
    ListSelectClub,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Statistiques/General/General_secretariat.vue